import { SocketClient } from "socker/client";
import { BinaryKeyValueStore } from "socker/shared";

const sockets = new Map<string, SocketClient>();

export type UseSocketProps = {
  url: string;
};

let pingInterval: ReturnType<typeof setInterval> | null = null;

const PING_INTERVAL: number = 5000;

export const useSocket = (props: UseSocketProps): SocketClient => {
  const sock = sockets.get(props.url);
  if (sock) return sock;

  const socketFactory = (): WebSocket => {
    queueMicrotask(() => {
      newSock.onReady((client) => {
        if (pingInterval !== null) {
          console.log(`Socket: cleared old ping interval`);
          clearInterval(pingInterval);
          pingInterval = null;
        }

        pingInterval = setInterval(() => {
          client.send(BinaryKeyValueStore.fromJS({
            action: 'PING',
            app: 'pingpong'
          }));
        }, PING_INTERVAL);
      });
    });

    return new WebSocket(props.url);
  };

  const newSock = new SocketClient({
    socket: socketFactory(),
    id: props.url,
    socketFactory: socketFactory,
  });

  sockets.set(props.url, newSock);
  return newSock;
};
